import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {MatchingsService} from "../../services/matchings.service";
import * as dataSourcesAd from "./dataSourcesAd.actions";
import {switchMap} from "rxjs";
import {map} from "rxjs/operators";

@Injectable()
export class DataSourcesAdEffects {

  public load$ = createEffect(() => this._actions.pipe(
    ofType(dataSourcesAd.loadDataSourcesAd),
    switchMap(() => this._matchingsS.getDataSourcesAd().pipe(
      map((dataSources) => dataSourcesAd.loadDataSourcesAdSuccess({
        dataSources: dataSources.data
      }))
    ))
  ));

  constructor(
    private readonly _actions: Actions,
    private readonly _matchingsS: MatchingsService
  ) {}

}
